import axios from "axios";
import spinnerInterceptor from "../interceptors/spinner.interceptor";
import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";

const http = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/vnd.appetize+json;version=1"
  }
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

function fetchVenues(showSpinner = true, applyToken = true) {
  return http.get("mobile/venues", {
    showSpinner,
    applyToken
  });
}

function fetchVenueById(venueId, showSpinner = true, applyToken = true) {
  return http.get(`mobile/venue/${venueId}`, {
    showSpinner,
    applyToken
  });
}

function fetchSubvendorInfo(vendorId, venueId, showSpinner = true, applyToken = true) {
  return http.get(`mobile/venue/${venueId}/vendor/${vendorId}/subvendors`, {
    showSpinner,
    applyToken
  });
}

function fetchVenueLevels(venueId, showSpinner = true, applyToken = true) {
  return http.get(`mobile/venue/${venueId}/levels`, {
    showSpinner,
    applyToken
  });
}

function fetchLevelSeats({ venueId, levelId }, showSpinner = true, applyToken = true) {
  return http.get(`mobile/venue/${venueId}/level/${levelId}/seats`, {
    showSpinner,
    applyToken
  });
}

function applyPromoCode(reqBody, userId, showSpinner = true, applyToken = true) {
  return http.post(`mobile/user/${userId}/cart`, reqBody, {
    showSpinner,
    applyToken
  });
}

function fetchUserOrders(userId, showSpinner = true, applyToken = true) {
  return http.get(`mobile/user/${userId}/orders`, {
    showSpinner,
    applyToken
  });
}

function fetchVisitorOrders(visitorId, count = 25, showSpinner = true, applyToken = true) {
  return http.get(`mobile/visitors/${visitorId}/orders?count=${count}`, {
    showSpinner,
    applyToken
  });
}

export default {
  fetchVenues,
  fetchVenueById,
  fetchSubvendorInfo,
  fetchVenueLevels,
  fetchLevelSeats,
  applyPromoCode,
  fetchUserOrders,
  fetchVisitorOrders
};
